import { render, staticRenderFns } from "./PathwayCard.vue?vue&type=template&id=55bc93b4&scoped=true&"
import script from "./PathwayCard.vue?vue&type=script&lang=js&"
export * from "./PathwayCard.vue?vue&type=script&lang=js&"
import style0 from "./PathwayCard.vue?vue&type=style&index=0&id=55bc93b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bc93b4",
  null
  
)

export default component.exports